import React from 'react';
import { SvgLoader, SvgProxy } from 'react-svgmt';
import { palette } from '../design-system/colors';
import { observer } from 'mobx-react';
const { REACT_APP_STATIC_PREFIX = '/static' } = import.meta.env;

/**
 * Step indicator in assessment.
 */

export const ThemedAssessmentStepIndicator = observer(
    ({ primaryColor, isCurrent, isActive }) => {
        return (
            <span>
                <SvgLoader
                    path={
                        isCurrent
                            ? `${REACT_APP_STATIC_PREFIX}/img/icon-step-active.svg`
                            : `${REACT_APP_STATIC_PREFIX}/img/icon-step.svg`
                    }
                >
                    <SvgProxy
                        selector="circle"
                        fill={isActive ? primaryColor : palette.graphite.ash}
                    />
                </SvgLoader>
            </span>
        );
    }
);
